import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from '../../../constants/breakpoints';

const styles = createUseStyles(theme => ({
  reportsTabbedNav: {
    "& .tab-content": {
      [`@media (max-width:${breakpoints.lg}px)`]: {
        marginTop: "42px"
      },
    }
  },
  tabs: {
    borderColor: theme.tabs.borderColor,
    "& li": {
      "& button": {
        marginRight:"16px",
        "&.nav-link": {
          border: "none",
          borderColor: theme.tabs.borderColor,
          color: theme.tabs.color,
          fontWeight:"600",
          padding: "0px 4px 9px",
          "&.active": {
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          },
          "&:hover":{
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          }
        },
        "&:focus-visible":{
          boxShadow: "0px 0px 0px 4px " + colors.primary500Blue
        },
      }
    }
  },
  missingAwardButton: {
    position: "absolute",
    right: 0,
    top: 0,
    padding: "0px",
    display: "flex",
    alignItems: "center",
    border: "none",
    color: colors.primary700Blue,
    fontWeight: "600",
    fontSize: "14px",
    "& span": {
      marginLeft: "4px"
    },
    "&:hover": {
      color: colors.darkBlue,
      cursor: "pointer",
      border: "none",
      borderRadius: 0,
      backgroundColor: colors.white,
      boxShadow: "none",
    },
    [`@media (min-width:731px) and (max-width:831px)`]: {
      top: "46px",
    },
    [`@media (min-width:832px) and (max-width:1025px)`]: {
      left: "-4px",
      top: "46px",
    },
    [`@media (max-width:${breakpoints.md}px)`]: {
      position: "static",
      marginTop: "10px",
      alignSelf: "flex-start",
    },
  },
  reportInfo:{
    display: "flex",
    alignItems: "center",
    "& p":{
      color: colors.choiceGray600,
      fontSize: "14px",
      fontWeight: "600px",
      textDecoration: "underline",
      textDecorationStyle: "solid",
      textDecorationSkipInk: "auto",
      textDecorationThickness: "auto",
      margin: "0px",
      marginLeft: "4px"
    }
  },
  iconStyle:{
    "& path": {
      stroke: theme.reportsInfoIcon.color
    },
    "&:hover": {
      "& path": {
        stroke: theme.reportsInfoIcon.color
      }
    }
  },
  infoPopoverDiv:{
    display:"flex",
    flexDirection:"column",
    alignItems:"start",
    backgroundColor: theme.flatpickr.popoverDiv.backgroundColor,
    padding: "12px",
    borderRadius: 8,
    color: theme.flatpickr.popoverDiv.color,
    width:"318px !important"
  },
  infoPopover:{
    "& .popover-arrow::before": {
      borderRightColor: theme.flatpickr.popoverDiv.color,
    },
    maxWidth: "320px !important",
    borderColor: theme.flatpickr.popoverDiv.border,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  },
  infoTitle:{
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "18px",
    marginBottom: "4px",
  },
  infoDescription:{
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "18px",
  },
}));

export default styles;

export const tabsSelectOpen = {
  dropdownIndicator: (base, { selectProps }) => ({
    ...base,
    padding:"12px",
    transition: selectProps.menuIsOpen ? 'all .2s ease' : "none",
    transform: selectProps.menuIsOpen ? 'rotate(180deg)' : "none",
    color: `${colors.grey} !important`
  }),
}
